@if (explorer.result(); as bewegungen) {
  <div class="flex flex-col-reverse full-width bg-surface lg:bg-transparent -mt-2 sticky -top-2 !z-10">
    <div class="lg:-mt-3 w-full p-4 pt-0 bg-surface border-b border-gray-300 border-solid">
      <div class="flex flex-col w-full mb-3">
        <div class="soft-overline mt-4">
          {{'#LLR_KOMMISSIONIERUNG.ARTIKELAUSWAHL.TITEL_ERFASSTE_ARTIKEL' | translate}}
        </div>
        <soft-filter-and-sort
          class="flex flex-row w-full mt-2"
          [filterConfig]="filterConfig"
          [sortConfig]="sortConfig"
          [explorer]="explorer">
        </soft-filter-and-sort>
      </div>
    </div>
    <soft-step-header class="hidden" [steps]="steps" [currentIndex]="0" [showLabels]="false" #stepper></soft-step-header>
    <soft-default-header
      class="px-4 pt-4 pb-3 bg-white border-b border-gray-300 border-solid"
      [overline]="stepper.stepText"
      [title]="$safeNavigationMigration(stepper.current()?.header)"
      [subtitle]="$safeNavigationMigration(stepper.current()?.subHeader)">
    </soft-default-header>
  </div>
  @if ((loading$ | async) === false) {
    <div class="flex flex-grow overflow-auto full-width w-full z-[0] lg:-mt-3 relative">
      <div class="flex flex-col w-full px-4 py-2 lg:py-4 mt-2">
        @for (bewegung of bewegungen; track bewegung) {
          @if ((abgeschlosseneArtikelAnzeigen && bewegung?.kommissionierDaten?.abgeschlossen) || !bewegung?.kommissionierDaten?.abgeschlossen) {
            <div
              class="soft-card rounded-sm flex flex-row w-full items-center justify-between cursor-pointer mb-3 !p-3"
              (click)="artikelpositionUebernehmen(bewegung.id)"
              [ngClass]="{'!bg-success-400': $safeNavigationMigration(bewegung?.kommissionierDaten?.abgeschlossen)}">
              <div class="flex flex-row w-full justify-between">
                <div class="flex flex-col w-4/5 gap-2">
                  <div class="flex flex-row w-full justify-between">
                    <div class="text-sm text-light">
                      {{bewegung?.bewebs?.artikel?.artikelnummer}}
                    </div>
                    @if (bewegung?.kommissionierDaten?.abgeschlossen) {
                      <div
                        class="text-sm text-light">
                        {{'#LLR_KOMMISSIONIERUNG.ARTIKELAUSWAHL.LABEL_ABGESCHLOSSEN' | translate}}
                      </div>
                    }
                  </div>
                  <div class="flex flex-row w-full">
                    <div class="font-semibold">
                      {{bewegung?.bewebs?.artikel?.artbez1}}
                    </div>
                  </div>
                  <div class="flex flex-row w-full">
                    <div class="text-sm text-light">
                      {{bewegung?.bewebs?.artikel?.artbez2}}
                    </div>
                  </div>
                </div>
                <div class="flex flex-row w-1/5 gap-4 self-center justify-end">
                  <div class="flex flex-col gap-2 justify-center items-end">
                    <div class="font-semibold">
                      {{$safeNavigationMigration(bewegung?.kommissionierDaten?.offene_menge) | number: '.0-3' }}
                      {{bewegung?.kommissionierDaten?.arteh?.arteh}}
                    </div>
                    @if (!paletteEinzelEingabe &&
                      (bewegung?.kommissionierDaten?.arteh?.arteh !== bewegung?.kommissionierDaten?.arteh_palette?.arteh) &&
                      (bewegung?.kommissionierDaten?.menge_pro_palette ?? 0 > 0)
                      ) {
                      <div
                        class="font-semibold">
                        = {{bewegung?.kommissionierDaten?.anz_paletten ?? 0}} {{bewegung?.kommissionierDaten?.arteh_palette?.arteh ?? 'Pal'}}
                      </div>
                      <div
                        class="font-semibold">
                        {{bewegung?.kommissionierDaten?.rest_menge ?? 0}} {{bewegung?.kommissionierDaten?.arteh?.arteh ?? ''}}
                      </div>
                    }
                  </div>
                  <div class="flex flex-col max-w-fit self-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  } @else {
    <div class="flex flex-col mt-5 pb-5 gap-3">
      <div class="flex soft-card rounded w-full h-24" *softRepeat="5">
        <div class="flex flex-col gap-2 items-start pb-1.5 pt-2">
          <div class="h-4 w-20 skeleton rounded"></div>
          <div class="h-4 w-24 skeleton rounded"></div>
          <div class="h-4 w-36 skeleton rounded"></div>
        </div>
      </div>
    </div>
  }
}

